import React from 'react';
import { useTheme } from 'styled-components';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons, DropdownList } from '@/js/libs/ui';

import { ToolbarButton } from './styled';

export interface PlaceholdersDropdownProps {
  placeholders: string[];
  onPlaceholderClick?: (placeholder: string) => void;
}

export const PlaceholdersDropdown: React.FC<PlaceholdersDropdownProps> = ({ placeholders, onPlaceholderClick }) => {
  const theme = useTheme();
  const [isActive, setIsActive] = React.useState<boolean>(false);

  const handlePlaceholderClick = useCallbackRef((placeholder: string) => {
    if (onPlaceholderClick) {
      onPlaceholderClick(placeholder);
    }
    setIsActive(false);
  });

  return (
    <DropdownList
      zIndex={1000}
      arrow={false}
      buttonComponent={
        <ToolbarButton data-testid='toolbar-button'>
          <Icons.Placeholder size={22} color={isActive ? theme.colors.black_1 : theme.colors.grey100_1} />
        </ToolbarButton>
      }>
      {placeholders.map((placeholderName) => (
        <DropdownList.Item
          onClick={() => handlePlaceholderClick(placeholderName)}
          key={placeholderName}
          data-testid={`placeholder-${placeholderName}`}>
          {placeholderName}
        </DropdownList.Item>
      ))}
    </DropdownList>
  );
};
